import { render, staticRenderFns } from "./FolderLeft.vue?vue&type=template&id=78bd87c3&scoped=true&"
import script from "./FolderLeft.vue?vue&type=script&lang=js&"
export * from "./FolderLeft.vue?vue&type=script&lang=js&"
import style0 from "./FolderLeft.vue?vue&type=style&index=0&id=78bd87c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd87c3",
  null
  
)

export default component.exports